export default __webpack_public_path__ + "static/jukebox-8f801e2299fb8c60013239f7a7ebcb5a.svg";